import buttonClasses from "@mui/material/Button/buttonClasses";
import touchRippleClasses from "@mui/material/ButtonBase/touchRippleClasses";
import { button, buttonIcon } from "../../styles/utils/button.module";
import { stripUnit } from "../../styles/utils/utils";
export const MuiButtonTheme = (dt) => {
    const inheritStyle = {
        [`&[disabled], &.disabled, &.${buttonClasses.disabled}`]: {
            ".PixelIcon": {
                opacity: dt.opacity.states.disabled.content,
            },
        },
    };
    return {
        defaultProps: {
            disableRipple: true,
            disableElevation: true,
        },
        styleOverrides: {
            root: {
                minHeight: dt.button.medium,
                paddingTop: 0,
                paddingRight: dt.button.padding.default,
                paddingBottom: 0,
                paddingLeft: dt.button.padding.default,
                borderRadius: dt.button.shape.borderRadius,
                borderWidth: dt.button.shape.border,
                minWidth: dt.button.minWidth,
                [`.${touchRippleClasses.root}`]: {
                    display: "none",
                },
                "&": {
                    textTransform: "initial", // Override MUI default,
                },
            },
            contained: {
                [`&.${buttonClasses.containedError}`]: button(dt.cta.contained, ["signal", "error"], dt),
                [`&.${buttonClasses.containedWarning}`]: button(dt.cta.contained, ["signal", "warning"], dt),
                [`&.${buttonClasses.containedSuccess}`]: button(dt.cta.contained, ["signal", "success"], dt),
                [`&.${buttonClasses.containedInfo}`]: button(dt.cta.contained, ["signal", "info"], dt),
                [`&.${buttonClasses.containedInherit}`]: inheritStyle,
            },
            containedPrimary: button(dt.cta.contained, ["primary"], dt),
            containedSecondary: button(dt.cta.contained, ["secondary"], dt),
            outlined: {
                [`&.${buttonClasses.outlinedError}`]: button(dt.cta.outlined, ["signal", "error"], dt),
                [`&.${buttonClasses.outlinedWarning}`]: button(dt.cta.outlined, ["signal", "warning"], dt),
                [`&.${buttonClasses.outlinedSuccess}`]: button(dt.cta.outlined, ["signal", "success"], dt),
                [`&.${buttonClasses.outlinedInfo}`]: button(dt.cta.outlined, ["signal", "info"], dt),
                [`&.${buttonClasses.outlinedInherit}`]: inheritStyle,
            },
            outlinedPrimary: button(dt.cta.outlined, ["primary"], dt),
            outlinedSecondary: button(dt.cta.outlined, ["secondary"], dt),
            text: {
                [`&.${buttonClasses.textError}[class][class]`]: button(dt.cta.outlined, ["signal", "error"], dt, {}, "text"),
                [`&.${buttonClasses.textWarning}[class][class]`]: button(dt.cta.outlined, ["signal", "warning"], dt, {}, "text"),
                [`&.${buttonClasses.textSuccess}[class][class]`]: button(dt.cta.outlined, ["signal", "success"], dt, {}, "text"),
                [`&.${buttonClasses.textInfo}[class][class]`]: button(dt.cta.outlined, ["signal", "info"], dt, {}, "text"),
                [`&.${buttonClasses.textInherit}`]: inheritStyle,
            },
            textPrimary: {
                "&[class][class]": button(dt.cta.outlined, ["primary"], dt, {}, "text"),
            },
            textSecondary: {
                "&[class][class]": button(dt.cta.outlined, ["secondary"], dt, {}, "text"),
            },
            sizeSmall: {
                minHeight: dt.button.small,
            },
            sizeMedium: {
                minHeight: dt.button.medium,
            },
            sizeLarge: {
                minHeight: dt.button.large,
            },
            iconSizeSmall: buttonIcon(dt.icon.size.small),
            iconSizeMedium: buttonIcon(dt.icon.size.medium),
            iconSizeLarge: buttonIcon(dt.icon.size.large),
            startIcon: {
                marginLeft: `${stripUnit(dt.button.padding.icon) - stripUnit(dt.button.padding.default)}px`,
            },
            endIcon: {
                marginRight: `${stripUnit(dt.button.padding.icon) - stripUnit(dt.button.padding.default)}px`,
            },
        },
    };
};
